import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import s from './Skeleton.scss';

const Skeleton = ({ circle, height, width, className }) => {
  return (
    <div
      className={cx(s.loading, circle && s.circle, className)}
      style={{ height, width }}
    />
  );
};

Skeleton.propTypes = {
  circle: PropTypes.bool,
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string,
};

Skeleton.defaultProps = {
  circle: false,
  width: '100px',
  height: '14px',
  className: null,
};

export default withStyles(s)(Skeleton);
